import { Input, InputGroup, InputRightElement, FormControl, FormErrorMessage, HStack, Text, Spinner, } from "@chakra-ui/react";
import { AlertIcon, TimesCircleIcon } from "./icons";
import { forwardRef, useCallback, useState } from "react";
export const Field = forwardRef(({ error, onClear, containerStyles, isLoading, ...inputProps }, ref) => {
    const [isActive, setIsActive] = useState(false);
    const onFocus = useCallback((e) => {
        setIsActive(true);
        inputProps.onFocus?.(e);
    }, [inputProps]);
    const onBlur = useCallback((e) => {
        setIsActive(false);
        inputProps.onBlur?.(e);
    }, [inputProps]);
    return (<FormControl align="flex-start" {...containerStyles} isInvalid={!!error}>
        <InputGroup>
          <Input {...inputProps} onFocus={onFocus} onBlur={onBlur} isInvalid={!!error} ref={ref}/>

          {isLoading ? (<InputRightElement>
              <Spinner color="text.secondary" size="sm"/>
            </InputRightElement>) : (inputProps.value &&
            onClear && (<InputRightElement onClick={onClear} cursor={isActive ? "pointer" : "default"} opacity={isActive ? 100 : 0} // workaround for onBlur handler triggeres before onClear
        >
                <TimesCircleIcon color="text.secondary" boxSize={6}/>
              </InputRightElement>))}
        </InputGroup>

        <FormErrorMessage>
          {error && (<HStack marginY={3}>
              <AlertIcon fontSize="xl" color="alert.foreground"/>
              <Text color="alert.foreground" fontSize="sm" w="full" overflowWrap="anywhere">
                {error}
              </Text>
            </HStack>)}
        </FormErrorMessage>
      </FormControl>);
});
//# sourceMappingURL=Field.jsx.map